import React, { Fragment, useEffect, useState } from 'react';
import {
  Row,
  CardBody,
  Card,
  Button,
  ButtonGroup,
  CustomInput,
  Input,
} from 'reactstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import {
  Separator,
  Colxx,
} from '../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import Languages from '../../../../../data/languages';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import {
  API_OpenAI_Assistant,
  gAPI_QuestionSets,
} from '../../../../../constants/APIs';
import { useSelector } from 'react-redux';

function Features({
  botSettings,
  saveIntegration,
  integration,
  integrationProperties,
  locale,
  allProperties,
}) {
  const propertyId = useSelector((state) => state?.settings?.propertyId);
  const [formatedProperties, setFormatedProperties] = useState([]);
  const [features, setFeatures] = useState(botSettings.features);
  const [languageGPT3, setLanguageGPT3] = useState([]);
  const [assistantList, setAssistantList] = useState([]);
  const [aiAssistant, setAIAssistant] = useState(
    features?.openAIAssistant?.assistantId
      ? features.openAIAssistant?.assistantId
      : ''
  );
  const [languageInstructions, setLanguageInstructions] = useState(
    botSettings?.languageInstructions !== null &&
      botSettings?.languageInstructions !== undefined
      ? botSettings?.languageInstructions
      : ''
  );
  const [imageInstructions, setImageInstructions] = useState(
    botSettings?.imageInstructions !== null &&
      botSettings?.imageInstructions !== undefined
      ? botSettings?.imageInstructions
      : ''
  );
  const [selectedProperty, setSelectedProperty] = useState(
    integrationProperties.length > 0 ? integrationProperties[0] : ''
  );

  useEffect(() => {
    const result = integrationProperties.map((id) => {
      return allProperties.find((elem) => elem.id === id);
    });
    setFormatedProperties(result);
  }, [integrationProperties, allProperties]);

  const handleChange = (event) => {
    setSelectedProperty(event.target.value);
  };
  //by default Gpt version
  useEffect(() => {
    if (features.generativeGPT3 && !features.versionGPT3) {
      setFeatures((prev) => ({ ...prev, versionGPT3: '7' }));
    }
  }, [features.generativeGPT3]);

  useEffect(() => {
    const languageList = Languages.map((elem) => {
      elem.checked = false;
      botSettings.features.languageGPT3.forEach((lang) => {
        if (lang === elem.code) {
          elem.checked = true;
        }
      });
      return elem;
    });

    setLanguageGPT3(languageList);
  }, [botSettings]);

  useEffect(() => {
    if (selectedProperty) {
      loadResponse();
    }
  }, [selectedProperty]);

  const handleCheckedSerach = (e) => {
    var feat = { ...features };
    feat.predictiveSearch = e;
    setFeatures(feat);
    botSettings.features = feat;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true
          ? 'Predictive search enabled successfully'
          : 'Predictive search disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: botSettings });
  };
  const handleCheckedUpsells = (e) => {
    var feat = { ...features };
    feat.addOnUpsells = e;
    setFeatures(feat);
    botSettings.features = feat;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true
          ? 'Add-on`s & upsells enabled successfully'
          : 'Add-on`s & upsells disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: botSettings });
  };
  const handleAutoLanguageDetection = (e) => {
    var feat = { ...features };
    feat.autoLanguageDetection = e;
    setFeatures(feat);
    botSettings.features = feat;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true
          ? 'Auto language detection enabled successfully'
          : 'Auto language detection disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: botSettings });
  };

  // openAI

  const loadResponse = async () => {
    return await AxiosAPI({
      methed: 'get',
      url: `${gAPI_QuestionSets}/?propertyId=${selectedProperty}&groupId=${getGroupID()}&lang=${locale}`,
    })
      .then((res) => {
        var setslist = res.data.sets.sort(
          (a, b) => a.displayOrder - b.displayOrder
        );
        var list = [];
        if (setslist !== null && setslist.length > 0) {
          setslist
            .filter(
              (l) =>
                l.type === 'DynamicConversationFlow' &&
                l.openAiAssistantId !== ''
            )
            .map((l) => {
              list.push({
                id: l.openAiAssistantId,
                name: l.name,
                isGroupLevel: l?.isGroupVisible ?? false,
              });
            });
        }

        setAssistantList(list);
      })
      .catch((err) => {
        console.error(
          'API error:',
          err.response ? err.response.data : err.message
        );
      });
  };
  //e.o.OpenAI
  const handleCheckedOpenAIEnabled = (e) => {
    const feat = { ...features };
    feat.fixedResponses = e === true ? false : true;
    feat.generativeGPT3 = false;
    feat.liveChatOnly = e === true ? false : true;
    var openai = { ...feat.openAIAssistant };
    openai.isEnabled = e;
    openai.versionDynamicFlow = e ? '6DynamicConverstionFlow' : '';

    feat.openAIAssistant = openai;
    setFeatures(feat);
  };
  // const handleCheckedOpenAIEnabled = (e) => {
  //   var feat = { ...features };
  //   feat.fixedResponses = e === true ? false : true;
  //   feat.generativeGPT3 = false;
  //   feat.liveChatOnly = e === true ? false : true;
  //   var openai = { ...feat.openAIAssistant };
  //   openai.isEnabled = e;
  //   feat.openAIAssistant = openai;
  //   setFeatures(feat);
  // };
  const handleChangeAssistantId = (e) => {
    setAIAssistant(e.target.value);
    var feat = { ...features };
    var openai = { ...feat.openAIAssistant };
    openai.assistantId = e.target.value;
    feat.openAIAssistant = openai;
    setFeatures(feat);
  };

  // const handleVersionDynamicFlowChange = (e) => {
  //   var feat = { ...features };
  //   var openai = { ...feat.openAIAssistant };
  //   openai.versionDynamicFlow = e;
  //   feat.openAIAssistant = openai;
  //   setFeatures(feat);
  // };

  const handleCheckedFixedResponses = (e) => {
    var feat = { ...features };
    feat.generativeGPT3 = e === true ? false : true;
    feat.liveChatOnly = e === true ? false : true;
    feat.fixedResponses = e;
    var openai = { ...feat.openAIAssistant };
    openai.isEnabled = false;
    feat.openAIAssistant = openai;
    setFeatures(feat);
    botSettings.features = feat;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true
          ? 'Fixed Responses enabled successfully'
          : 'Fixed Responses disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: botSettings });
  };

  const handleCheckedLiveChatOnly = (e) => {
    var feat = { ...features };
    feat.generativeGPT3 = e === true ? false : true;
    feat.fixedResponses = e === true ? false : true;
    feat.liveChatOnly = e;
    var openai = { ...feat.openAIAssistant };
    openai.isEnabled = false;
    feat.openAIAssistant = openai;
    setFeatures(feat);
    botSettings.features = feat;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true
          ? 'Live Chat Only enabled successfully'
          : 'Live Chat Only disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: botSettings });
  };

  const handleCheckedGenerativeGTP3 = (e) => {
    var feat = { ...features };
    feat.fixedResponses = e === true ? false : true;
    feat.generativeGPT3 = e;
    feat.liveChatOnly = e === true ? false : true;
    var openai = { ...feat.openAIAssistant };
    openai.isEnabled = false;
    feat.openAIAssistant = openai;
    setFeatures(feat);
    botSettings.features = feat;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true
          ? 'Generative GTP3 enabled successfully'
          : 'Generative GTP3 disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: botSettings });
  };
  const handleCheckedGenerativeChatGTP = (e) => {
    var feat = { ...features };
    feat.generativeChatGPT = e;
    setFeatures(feat);
    botSettings.features = feat;
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true
          ? 'Generative ChatGTP enabled successfully'
          : 'Generative ChatGTP disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: botSettings });
  };
  const handleLanguageChange = (e) => {
    const values = languageGPT3.map((elem) => {
      if (elem.code === e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    setLanguageGPT3(values);
    const langArr = values
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.code);
    setFeatures({ ...features, languageGPT3: langArr });
  };
  // const handleVersionGPT3Change = (e) => {
  //   var feat = { ...features };
  //   feat.versionGPT3 = e;
  //   setFeatures(feat);
  // };
  const handleVersionGPT3Change = (e) => {
    var feat = { ...features };
    feat.versionGPT3 = e;
    console.log('123', e);
    if (e === '7') {
      feat.reasoningEfforts = 'minimal';
    }

    setFeatures(feat);
  };

  // const handleReasoningEffortsChange = (e) => {
  //   var feat = { ...features };
  //   feat.reasoningEfforts = e;
  //   setFeatures(feat);
  // };
  const handleVerbosityChange = (e) => {
    var feat = { ...features };
    feat.verbosity = e;
    setFeatures(feat);
  };
  const handleSave = () => {
    features.reasoningEfforts = 'minimal';
    botSettings.features = features;
    botSettings.languageInstructions = languageInstructions;
    botSettings.imageInstructions = imageInstructions;
    saveIntegration({ botSetting: botSettings });
  };

  const handleCheckedPreTrained = (e) => {
    var feat = { ...features };
    var intent = { ...feat.intentRecognition };
    intent.isPreTrainedIndustry = e;
    intent.isStaticConversationFlow =
      intent.isStaticConversationFlow === true ? false : false;
    feat.intentRecognition = intent;
    setFeatures(feat);
    botSettings.features = feat;
    saveIntegration({ botSetting: botSettings });
  };

  const handleImageRecogniation = (e) => {
    var feat = { ...features };
    var intent = { ...feat.imageRecognition };
    intent.isPreBuildTemplates = e;
    intent.isDynamicFlow = intent.isDynamicFlow === true ? false : false;
    feat.imageRecognition = intent;
    setFeatures(feat);
    botSettings.features = feat;
    // saveIntegration({ botSetting: botSettings });
  };
  const handleImageRecogniationDynamic = (e) => {
    var feat = { ...features };
    var intent = { ...feat.imageRecognition };
    intent.isDynamicFlow = e;
    intent.isPreBuildTemplates =
      intent.isPreBuildTemplates === true ? false : false;
    feat.imageRecognition = intent;
    setFeatures(feat);
    botSettings.features = feat;
    // saveIntegration({ botSetting: botSettings });
  };

  const handleCheckedStaticFlow = (e) => {
    var feat = { ...features };
    var intent = { ...feat.intentRecognition };
    intent.isPreTrainedIndustry = e === true ? false : true;
    intent.isStaticConversationFlow = e;
    feat.intentRecognition = intent;
    setFeatures(feat);
    botSettings.features = feat;
    saveIntegration({ botSetting: botSettings });
  };

  const handleChangeStaticAssistantId = (e) => {
    var feat = { ...features };
    var intent = { ...feat.intentRecognition };
    intent.assistantId = e.target.value;
    feat.intentRecognition = intent;
    setFeatures(feat);
  };

  const assistantRecord = assistantList?.find(
    (assist) => assist?.id == aiAssistant
  );

  const isNavigateToConversationFlow =
    assistantRecord?.isGroupLevel == true
      ? propertyId == '-1'
      : propertyId != '-1';

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6>AI Features & Language Settings </h6>
            <p>
              This section helps you decide how your AI talks with guests. You
              can choose the style of conversation and turn on auto language
              detection so every guest feels understood and welcomed.
            </p>
          </div>
          {integration === undefined && <Separator className="mb-3" />}
          {integration === undefined && (
            <div className="row mt-1 ml-2 mb-1">
              <div className="d-flex w-100">
                <h5 style={{ marginTop: '0.15rem' }}>Predictive search</h5>
                <Switch
                  className="agentswitch custom-switch-primary custom-switch-small ml-2"
                  checked={features.predictiveSearch}
                  name="predictiveSearch"
                  onChange={(e) => handleCheckedSerach(e)}
                />
              </div>
              <div className="row " style={{ marginLeft: '0.5rem' }}>
                <p className="m-2">
                  When enabled, user will see predictive suggestions as they
                  type the message
                </p>
              </div>
            </div>
          )}
          {integration === undefined && <Separator className="mb-3" />}
          {integration === undefined && (
            <div className="row mt-1 ml-2 mb-1">
              <div className="d-flex w-100">
                <h5 style={{ marginTop: '0.15rem' }}>Add-on's & upsells</h5>
                <Switch
                  className="agentswitch custom-switch-primary custom-switch-small ml-2"
                  checked={features.addOnUpsells}
                  name="enabled"
                  onChange={(e) => handleCheckedUpsells(e)}
                />
              </div>
              <div className="row " style={{ marginLeft: '0.5rem' }}>
                <p className="m-2">
                  When enabled, guests will be shown the Add-on and upsell
                  options available
                </p>
              </div>
            </div>
          )}

          <Separator className="mb-3" />
          <div className="ml-2">
            <h5 style={{ marginTop: '0.15rem' }}>Choose your NLP </h5>
            <div className="d-flex ml-2 mt-2">
              <h7 style={{ marginTop: '0.15rem' }}>Live Chat Only (No AI)</h7>
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                checked={features.liveChatOnly}
                name="liveChatOnly"
                onChange={(e) => handleCheckedLiveChatOnly(e)}
              />
            </div>
            <p className="ml-2">
              Conversations are forwarded to Live Chat agents directly.{' '}
            </p>
            {/* <div className="d-flex ml-2 mt-2">
              <h7 style={{ marginTop: '0.15rem' }}>Fixed Responses</h7>
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                checked={features.fixedResponses}
                name="fixedResponses"
                onChange={(e) => handleCheckedFixedResponses(e)}
              />
            </div> */}
            <div className="d-flex ml-2 mb-2 mt-2">
              <h7 style={{ marginTop: '0.15rem' }}>Gen AI</h7>
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                checked={features.generativeGPT3}
                name="generativeGPT3"
                onChange={(e) => handleCheckedGenerativeGTP3(e)}
              />
            </div>
            <p className="ml-2">
              Gen AI excels at answering questions by using your Knowledge Hub
              to provide accurate and relevant information.
            </p>
            {features.generativeGPT3 && (
              <Fragment>
                <div className="mb-2 ml-2 mt-2 mr-2">
                  <h7>Select Version</h7>
                  <Input
                    type="select"
                    name="version"
                    value={features.versionGPT3}
                    onChange={(e) => handleVersionGPT3Change(e.target.value)}
                    className="mt-1"
                  >
                    <option value="">Select</option>
                    <option value="6">Version 6 (GPT-4o-mini)</option>
                    <option value="7">Version 7 (GPT-5-mini)</option>
                    <option value="AzureGpt4">
                      {' '}
                      Azure OpenAI (gpt-4o-mini)
                    </option>
                  </Input>
                </div>
                {features.versionGPT3 === '7' && (
                  <Fragment>
                    {/* <div className="mb-2 ml-2 mt-2 mr-2 ">
                      <h7>Reasoning Efforts</h7>
                      <Input
                        type="select"
                        name="reasoningefforts"
                        value={features.reasoningEfforts}
                        onChange={(e) => handleReasoningEffortsChange(e.target.value)}
                        className="mt-1"
                      >
                        <option value="">Select</option>
                        <option value="minimal">Minimal</option>
                        <option value="low">Low</option>
                        <option value="medium">Medium</option>
                        <option value="high">High</option>
                      </Input>
                    </div> */}
                    <div className="mb-2 ml-2 mt-2 mr-2">
                      <h7>Verbosity</h7>
                      <Input
                        type="select"
                        name="verbosity"
                        value={features.verbosity}
                        onChange={(e) => handleVerbosityChange(e.target.value)}
                        className="mt-1"
                      >
                        <option value="">Select</option>
                        <option value="low">Low</option>
                        <option value="medium">Medium</option>
                        <option value="high">High</option>
                      </Input>
                    </div>
                  </Fragment>
                )}
                <div
                  className="mb-1 ml-2 text-center"
                  style={{ display: 'none' }}
                >
                  <b>Choose Languages</b>
                  <br />
                  <Row className="mt-2">
                    {languageGPT3.map((elem, index) => (
                      <Colxx xxs="4">
                        {' '}
                        <CustomInput
                          key={index}
                          type="checkbox"
                          value={elem.code}
                          id={elem.code}
                          onChange={handleLanguageChange}
                          checked={elem.checked}
                          className="text-left"
                        >
                          {elem.name}
                        </CustomInput>
                      </Colxx>
                    ))}
                  </Row>
                </div>
              </Fragment>
            )}
            <div className="d-flex ml-2 mb-2 mt-2">
              <h7 style={{ marginTop: '0.15rem', marginBottom: '4px' }}>
                Dynamic Conversation Flow
              </h7>
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                checked={features?.openAIAssistant?.isEnabled}
                name="openAIisEnabled"
                onChange={(e) => handleCheckedOpenAIEnabled(e)}
              />
            </div>
            <p className="ml-2 mb-2">
              Conversation flows are useful to provide more detailed,
              step-by-step instructions to guide a customer through a process or
              task until completion.
            </p>

            <div className="d-none">
              <h5 style={{ marginTop: '0.15rem' }}>Generative ChatGPT</h5>
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                checked={features.generativeChatGPT}
                name="generativeChatGPT"
                onChange={(e) => handleCheckedGenerativeChatGTP(e)}
              />
            </div>
          </div>

          {features?.openAIAssistant?.isEnabled === true &&
            formatedProperties !== null && (
              <Fragment>
                {/* <Separator className="mb-3 mt-2" /> */}
                {formatedProperties.length > 1 && (
                  <div className="mb-1 ml-2 ">
                    <h6>Properties</h6>

                    <Input
                      className="border p-2 mb-3"
                      type={formatedProperties.length > 1 ? 'select' : 'text'}
                      name="Property Id"
                      value={
                        formatedProperties.length > 1
                          ? selectedProperty
                          : `${formatedProperties[0].name} (${formatedProperties[0].id})`
                      }
                      onChange={
                        formatedProperties.length > 1 ? handleChange : undefined
                      }
                    >
                      {formatedProperties.length > 1 ? (
                        formatedProperties.map((list, index) => (
                          <option key={index} value={list.id}>
                            {`${list.name} (${list.id})`}
                          </option>
                        ))
                      ) : (
                        <>{`${formatedProperties[0].name} (${formatedProperties[0].id})`}</>
                      )}
                    </Input>
                  </div>
                )}
              </Fragment>
            )}
          {assistantList &&
            assistantList !== null &&
            features?.openAIAssistant?.isEnabled === true && (
              <Fragment>
                {/* <Separator className="mb-3" /> */}
                <div className="mb-1 ml-2 ">
                  {/* <h6>Dynamic Conversation Flow</h6> */}

                  {/* <Input
                                    type="text"
                                    name="assistantId"
                                    onChange={handleChangeAssistantId}
                                    placeholder="Assistant Id"
                                    value={assistantList.map(assist => `${assist.name} (${assist.id})`).join(', ')}
                                // defaultValue={features.openAIAssistant.assistantId}
                                /> */}
                  {assistantList.length > 0 ? (
                    <Input
                      className="border p-2 mb-3"
                      type="select"
                      name="assistantId"
                      placeholder="Dynamic Conversation Flow"
                      value={aiAssistant}
                      onChange={handleChangeAssistantId}
                    >
                      <option value="" disabled>
                        Select a Dynamic Conversation Flow
                      </option>
                      {assistantList.map((assist, index) => (
                        <option key={index} value={assist.id}>
                          {assist.isGroupLevel
                            ? `${assist.name} (${assist.id}) (Group Level)`
                            : `${assist.name} (${assist.id})`}
                        </option>
                      ))}
                    </Input>
                  ) : (
                    <Input
                      className="border p-2 mb-3"
                      type="text"
                      name="assistantId"
                      onChange={handleChangeAssistantId}
                      placeholder="Dynamic Conversation Flow"
                      defaultValue={aiAssistant}
                    />
                  )}
                  {/* <Input
                    type="select"
                    name="versionDynamicFlow"
                    value={features.openAIAssistant.versionDynamicFlow}
                    onChange={(e) =>
                      handleVersionDynamicFlowChange(e.target.value)
                    }
                  >
                    <option value="">Select</option>
                    <option value="6DynamicConverstionFlow">
                      Version 6 (with Dynamic Conversation Flow)
                    </option>
                  </Input> */}

                  {aiAssistant && isNavigateToConversationFlow && (
                    <div className="mt-1">
                      <a
                        href={`/app/pages/propinfo/recommender?assistantId=${aiAssistant}`}
                        target="_self"
                        rel="noopener noreferrer"
                        style={{
                          color: 'red',
                          textDecoration: 'underline',
                          fontSize: '15px',
                        }}
                      >
                        Go to conversation flow
                      </a>
                    </div>
                  )}
                </div>
              </Fragment>
            )}

          {features?.openAIAssistant?.isEnabled !== true && (
            <div className="mb-2 ml-3">
              <Button
                variant="contained"
                color="primary"
                size="xs"
                onClick={() =>
                  (window.location.href = '/app/pages/propinfo/recommender')
                }
              >
                Create a New Flow
              </Button>
            </div>
          )}

          <Separator className="mb-3" />
          <div className="ml-2 mb-3">
            <h5 style={{ marginTop: '0.15rem' }}>Choose Image Search Method</h5>
            <div className="d-flex ml-2 mt-2">
              <h7 style={{ marginTop: '0.15rem' }}>
                By default, images are displayed based on the placement of
                images in the Obsolete.
              </h7>
              {/* <Switch
                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                checked={features?.imageRecognition?.isPreBuildTemplates}
                name="isPreBuildTemplates"
                onChange={(e) => handleImageRecogniation(e)}
              /> */}
            </div>
            <Fragment>
              <div className="mt-2 ml-2 mb-2">
                <h5 style={{ marginTop: '0.15rem' }}>Image Instructions</h5>
                <p className="m-2">
                  You can use this prompt to help an AI Chatbot to search
                  images, giving it clear instructions on how to handle
                  specific, unique words. Only used with the Gen AI option.
                </p>
                <Input
                  className="mt-2"
                  type="textarea"
                  rows="3"
                  value={imageInstructions}
                  onChange={(e) => {
                    setImageInstructions(e.target.value);
                  }}
                />
              </div>
            </Fragment>
            <div className="d-flex ml-2 mt-2">
              <h7 style={{ marginTop: '0.15rem' }}>
                Dynamic based on image captions and tags
              </h7>
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                checked={features?.imageRecognition?.isDynamicFlow}
                name="isDynamicFlow"
                onChange={(e) => handleImageRecogniationDynamic(e)}
              />
            </div>
          </div>
          {/* <Separator className="mb-3" style={{ display: 'none' }} /> */}
          <div className="ml-2 " style={{ display: 'none' }}>
            <h5 style={{ marginTop: '0.15rem' }}>
              Choose Intent Recognition Method
            </h5>
            <div className="d-flex ml-2 mt-2">
              <h7 style={{ marginTop: '0.15rem' }}>
                Pre-Trained Industry Method
              </h7>
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                checked={
                  features.intentRecognition
                    ? features.intentRecognition.isPreTrainedIndustry
                    : true
                }
                name="isPreTrainedIndustry"
                onChange={(e) => handleCheckedPreTrained(e)}
              />
            </div>
            <div className="d-flex ml-2 mt-2">
              <h7 style={{ marginTop: '0.15rem' }}>
                Based on Static Conversation Flows
              </h7>
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                checked={
                  features.intentRecognition
                    ? features.intentRecognition.isStaticConversationFlow
                    : true
                }
                name="isStaticConversationFlow"
                onChange={(e) => handleCheckedStaticFlow(e)}
              />
            </div>
            {features.intentRecognition?.isStaticConversationFlow && (
              <div className="d-flex ml-2 mt-2">
                <Input
                  className="border p-2 mb-3"
                  type="text"
                  name="assistantId"
                  onChange={handleChangeStaticAssistantId}
                  placeholder="Assistant Id"
                  defaultValue={features.intentRecognition.assistantId}
                />
              </div>
            )}
          </div>
          <Separator className="mb-3" />
          <div className="row mt-1 ml-2 mb-1">
            <div className="d-flex w-100">
              <h5 style={{ marginTop: '0.15rem' }}>Auto Language Detection</h5>
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                checked={features.autoLanguageDetection}
                name="enabled"
                onChange={(e) => handleAutoLanguageDetection(e)}
              />
            </div>
            <div
              className="row "
              style={{ marginLeft: '0', marginRight: '1rem' }}
            >
              <p className="m-2">
                When enabled, the language will be auto detected based on the
                first two messages guest sends. Rest of the conversation will be
                in that language.
              </p>
            </div>
          </div>
          <Fragment>
            <div className="mt-2 ml-2 mb-2">
              <h5 style={{ marginTop: '0.15rem' }}>Language Instructions</h5>
              <p className="m-2">
                You can use this prompt to help an AI Chatbot translate text,
                giving it clear instructions on how to handle specific, unique
                words. Only used with the Gen AI option.
              </p>
              <Input
                className="mt-2"
                type="textarea"
                rows="3"
                value={languageInstructions}
                onChange={(e) => {
                  setLanguageInstructions(e.target.value);
                }}
              />
            </div>
          </Fragment>

          <Separator className="mb-3 mt-5" />
          <div className="text-center">
            <ButtonGroup className="mb-2 mt-2">
              <Button color="primary" size="xs" onClick={handleSave}>
                Save
              </Button>
            </ButtonGroup>
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
}

export default Features;
